import sessionVars from '@/helpers/sessionVars';
import http from '@/services/api/http';
import querystring from '@/utils/query-string';

export default {
  getHeaders() {
    return http.get('api/Browse/Headers');
  },
  getFilters(headerId) {
    return http.get(`api/Browse/Filters/${headerId}`);
  },
  getFilteredMarkets(
    headerId,
    itemsPerPage,
    page,
    filterIds,
    sort,
    sortParameter,
    dateFrom,
    dateTo,
  ) {
    const query = querystring.stringify({
      itemsPerPage,
      page,
      filterIds,
      sort,
      sortParameter,
      // Absolute range so the URL/request stay reproducible across days -
      // see Google's "avoid relative URL params" guidance.
      ...(dateFrom && dateTo ? { dateFrom, dateTo } : {}),
    });
    return http.get(`api/Browse/FilteredMarkets/${headerId}?${query}`);
  },
  getNewArrivalMarkets(limit = 1) {
    return http.get(
      `api/Browse/FilteredMarkets/0?itemsPerPage=${limit}&page=1&filterIds=&sort=newest&excludeMarketsOutsidePriceLimit=true&sortParameter=`,
    );
  },
  getMostPredictedMarkets(limit = 1) {
    return http.get(
      `api/Browse/FilteredMarkets/0?itemsPerPage=${limit}&page=1&filterIds=&sort=traded&excludeMarketsOutsidePriceLimit=true&sortParameter=ALL`,
    );
  },
  getTrendingMarkets(limit = 1) {
    return http.get(
      `api/Browse/FilteredMarkets/0?itemsPerPage=${limit}&page=1&filterIds=&sort=traded&excludeMarketsOutsidePriceLimit=true&sortParameter=TODAY`,
    );
  },
  getBiggestMoverMarkets(limit = 1) {
    return http.get(
      `api/Browse/FilteredMarkets/0?itemsPerPage=${limit}&page=1&filterIds=&sort=movers&excludeMarketsOutsidePriceLimit=true&sortParameter=TODAY`,
    );
  },
  getCarousel() {
    let utmSource = sessionVars.get('utm_source');
    if (utmSource) {
      utmSource = utmSource.value;
    }
    let utmCampaign = sessionVars.get('utm_campaign');
    if (utmCampaign) {
      utmCampaign = utmCampaign.value;
    }
    let utmCode = sessionVars.get('utm_code');
    if (utmCode) {
      utmCode = utmCode.value;
    }
    let PIReferral = sessionVars.get('PIReferral');
    if (PIReferral) {
      PIReferral = PIReferral.value;
    }
    return http.get(
      `api/Browse/Carousel?promoCode=${utmCode}&marketingProgram=${utmCampaign}&marketingSource=${utmSource}&piReferral=${PIReferral}`,
    );
  },
  getSearch(query, page = 1, itemsPerPage = 30) {
    return http.get(`api/Browse/Search/${query}?page=${page}&itemsPerPage=${itemsPerPage}`);
  },
  getHomePageGainModule(isLoss = false, days = 1, contracts = 2) {
    return http.get(
      `api/Browse/HomePage/GainModule?isLoss=${isLoss}&days=${days}&contracts=${contracts}`,
    );
  },
  getWidgets() {
    // const url = env.USE_API_WRAPPER ?
    //   'api/Public/GetLiveData?url=/api/Browse/Widgets' :
    //   'api/Browse/Widgets';
    return http.get('/api/Browse/Widgets');
  },
  getStoriesNav() {
    return http.get('api/Browse/Stories/Nav');
  },
  getStoriesList(indexes) {
    return http.get(`api/Browse/Stories/List?indexes=${indexes.join(',')}`);
  },
  getStory(index) {
    return http.get(`api/Browse/Stories/${index}`);
  },
  getStoryDetail(index) {
    return http.get(`api/Browse/Stories/${index}/Detail`);
  },
  getStaticPageDetail(key, options) {
    return http.get(`api/Browse/StaticPage/${encodeURIComponent(key)}`, options);
  },
  getStaticPagePreview(id) {
    return http.get(`api/Browse/StaticPagePreview/${id}`);
  },
  getStoryFullPreview(id) {
    return http.get(`api/Browse/StoryFullPreview/${id}`);
  },
};
